import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SmsAuthSetupStepComponent } from 'app/components/v2-layout/shared/two-factor-setup-steps/sms-auth-setup-step.component';
import { RECOVERY_CODES_GATE_COPY } from 'app/components/v2-layout/shared/two-factor-gate-dialog/two-factor-gate-dialog.component';

/**
 * Settings → Security wrapper: hosts the shared {@link SmsAuthSetupStepComponent}
 * inside a dialog so SMS enrollment is identical to the 2FA gate stepper and the
 * enrollment logic lives in exactly one place. Preserves the existing open()/afterClosed
 * contract — resolves `{success: true}` once enrolled and `undefined` on cancel — so the
 * Settings tab is unchanged (SD-8102).
 */
@Component({
    selector: 'app-setup-sms-authentication',
    templateUrl: './setup-sms-authentication.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatDialogModule,
        SmsAuthSetupStepComponent,
    ],
})
export class SetupSmsAuthenticationComponent
{
    constructor(private _dialogRef: MatDialogRef<SetupSmsAuthenticationComponent>) {
    }

    /** Dialog heading — swaps when the step reaches its show-once recovery-codes stage. */
    title = 'Enable Text Message Authentication';

    /**
     * The codes render inside this dialog, so the heading describes them rather than enrollment.
     *
     * Also locks the dialog: the method is enrolled and the codes generated by this point, so an
     * ESC or backdrop click would discard the only view of them. Dismissal stays available for the
     * enrollment stages before this.
     */
    onShowingRecoveryCodes(): void {
        this.title = RECOVERY_CODES_GATE_COPY.title;
        this._dialogRef.disableClose = true;
    }

    onCompleted(): void {
        this._dialogRef.close({success: true});
    }

    onCancelled(): void {
        this._dialogRef.close();
    }
}
